<script>
    export default {
        props: {
            taskListTemplate: {
                type: Object,
                required: true,
            },
            task: {
                required: true,
                type: Object,
            },
        },
        methods: {
            async deleteTask() {
                try {
                    await axios.delete(route('api.task-templates.destroy', this.task.id));
                    flash_success('Borttagen!');

                    this.$emit('deleted');
                } catch (e) {
                    flash_error('Kunde inte ta bort ditt item, försök igen!');
                }
            },
            async update() {
                try {
                    const data = {
                        ...{
                            _method: 'PATCH',
                            body: this.editedBodyText,
                            task_template_parent_id: this.task.task_template_parent_id,
                        },
                        ... this.extraData,
                    };

                    await axios.post(route('api.task-templates.update', this.task.id), data);

                    this.$nextTick(() => {
                        this.task.body = this.editedBodyText;
                    });

                    flash_success('Uppdaterad!');
                } catch (e) {
                    flash_error('Kunde tyvärr inte uppdatera, försök igen!');
                }
            },
        },
    };
</script>